@if (cistern$ | async; as cistern) {
  <app-card class="main-container" [loading]="(loading$ | async) ?? false">
    <div class="header">
      <a (click)="onBack()" class="button icon-button">
        <app-icon name="ic_chevron_left" />
        <span class="hidden-on-mobile">{{ "default.back" | translate }}</span>
      </a>

      <div class="actions">
        <button
          type="button"
          class="button icon-button"
          (click)="onEdit(cistern)"
        >
          <app-icon name="ic_edit" />
          {{ "default.edit" | translate }}
        </button>

        <app-context-menu [menuItems]="getContextMenu(cistern)" />
      </div>
    </div>

    <div class="content">
      <div class="flex mb-2">
        <h3>
          <app-text-with-icon name="ic_cistern">
            {{ cistern.name }}
          </app-text-with-icon>
        </h3>
      </div>

      <table class="transparent">
        <tr>
          <th>{{ "cisterns.detail.fillLevel" | translate }}</th>
          <td>
            {{
              (cistern.currentWaterPercentage ?? 0) / 100
                | localizedPercent: "1.0-0"
            }}
          </td>
        </tr>
        <tr>
          <th>{{ "cisterns.detail.currentVolume" | translate }}</th>
          <td>
            {{ cistern.currentWaterVolume ?? 0 | localizedNumber: "1.0-0" }} l
          </td>
        </tr>
        <tr>
          <th>{{ "cisterns.detail.capacity" | translate }}</th>
          <td>{{ cistern.literCapacity ?? 0 | localizedNumber: "1.0-0" }} l</td>
        </tr>
        <tr>
          <th>{{ "cisterns.detail.maxWaterLevelDistance" | translate }}</th>
          <td>
            {{
              cistern.maxWaterLevelDistance ?? 0 | localizedNumber: "1.0-0"
            }}
            cm
          </td>
        </tr>
        <tr>
          <th>{{ "cisterns.detail.floorDistance" | translate }}</th>
          <td>
            {{ cistern.floorDistance ?? 0 | localizedNumber: "1.0-0" }} cm
          </td>
        </tr>
      </table>
    </div>
    @if (getSensorDevice(cistern); as sensorDevice) {
      <div class="content">
        <h3 class="mb-2">{{ "cisterns.detail.sensor" | translate }}</h3>
        <div class="grid grid-cols-2">
          <app-device-item-card
            [device]="sensorDevice"
            [disabled]="true"
            [hideFavoriteIcon]="true"
          />
        </div>
      </div>
    }
  </app-card>

  <div class="detail-container">
    <app-map-with-location [device]="getMapDevice(cistern)" />
    <app-cistern-item-card [cistern]="cistern" [navigateToStatistics]="true" />
  </div>
} @else {
  <app-not-found [error]="getError()" [loading]="(loading$ | async) ?? false" />
}
